import * as React from 'react';
import { Text } from '@serodigital/ui-components';

export function ColourStatus({ label }) {
  return (
    <div
      data-qa="colour-status"
      className="border border-grey-medium rounded-[100px] bg-brand-neutral text-center text-common-white"
    >
      <Text>{label}</Text>
    </div>
  );
}
